import { useQuery } from "@tanstack/react-query";
import {
  EuTaxonomyCompanyActivityDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EU_TAXONOMY_ACTIVITY } from "../domain";

import { euTaxonomyCompanyActivityApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_COMPANY_ACTIVITIES = "GET_COMPANY_ACTIVITIES";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type GetCompanyActivitiesProps = {
  companyId?: string;
  year?: string;
};

const getCompanyActivities = async (
  props: GetCompanyActivitiesProps,
): Promise<EuTaxonomyCompanyActivityDto[]> => {
  const response =
    await euTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerGetEuTaxonomyCompanyActivities(
      props.companyId,
      props.year,
    );

  return response.data;
};

export const useGetCompanyActivities = (
  user: UserProfileDto | null,
  props?: GetCompanyActivitiesProps,
): {
  companyActivities?: EuTaxonomyCompanyActivityDto[];
  companyActivitiesEnabled: boolean;
  isLoadingGetCompanyActivities: boolean;
  isSuccessGetCompanyActivities: boolean;
  refetchCompanyActivities: () => void;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const shouldFetch = Boolean(props?.companyId || props?.year);

  const { isLoading, data, isSuccess, refetch } = useQuery({
    queryKey: [DOMAIN_EU_TAXONOMY_ACTIVITY, ACTION_GET_COMPANY_ACTIVITIES, props],
    queryFn: () => getCompanyActivities(props!),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled: shouldFetch && enabled,
    retry: 1,
  });

  return {
    companyActivities: data,
    companyActivitiesEnabled: enabled,
    isLoadingGetCompanyActivities: isLoading,
    isSuccessGetCompanyActivities: isSuccess,
    refetchCompanyActivities: refetch,
  };
};
